import React from 'react';

export const SUI = () => (
  <svg 
    width="1em" 
    height="1em" 
    viewBox="0 0 32 32" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm-.5 23.5v-15c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5zm-7.5-7.5c0-4.142 3.358-7.5 7.5-7.5v15c-4.142 0-7.5-3.358-7.5-7.5z"/>
  </svg>
);
